<header class="header-container">
    <div class="header-content">
        <ng-content></ng-content>
    </div>
</header>